/* ============================================================
   REUSE MEDICAL — Open Filter Groups by Default
   Add to: Assets/custom-filters.js
   Then reference in theme.liquid before </body>:
   {{ 'custom-filters.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  function openFilters() {
    /* Target all filter <details> elements in Dawn's facet sidebar */
    var filterDetails = document.querySelectorAll(
      'details.js-filter, ' +
      '.facets__disclosure, ' +
      '#FacetFiltersForm details, ' +
      '.facets-wrapper details, ' +
      'facet-filters-form details'
    );

    filterDetails.forEach(function (el) {
      el.setAttribute('open', '');
    });
  }

  /* Run on initial page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFilters);
  } else {
    openFilters();
  }

  /* Re-run after Shopify re-renders filters via AJAX
     (happens when a filter is selected in Dawn) */
  document.addEventListener('shopify:section:load', openFilters);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        var hasFilterNode = false;
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (
            node.matches && (
              node.matches('details.js-filter') ||
              node.matches('.facets__disclosure') ||
              node.closest('#FacetFiltersForm')
            )
          )) {
            hasFilterNode = true;
          }
        });
        if (hasFilterNode) openFilters();
      }
    });
  });

  /* Observe the filter container so re-renders are caught */
  var filterContainer = document.querySelector(
    '#FacetFiltersForm, .facets-wrapper, facet-filters-form'
  );
  if (filterContainer) {
    observer.observe(filterContainer, { childList: true, subtree: true });
  }
})();
